import { ReplaySubject } from 'rxjs/ReplaySubject';
import { enCurrency } from 'interfaces/IProductData';
import { Observable } from 'rxjs/Observable';
import { parameterService } from './ParameterService';
import { enParameters } from 'enums/enParameters';
import { enLang } from '../interfaces/IProductData';

export class CurrencyService {
  private currency$ = new ReplaySubject<enCurrency>(1);

  constructor() {
    parameterService.get(enParameters.lang).subscribe((lang) => {
      if (lang && lang != enLang.PT_BR) {
        this.setCurrency(enCurrency.USD);
      } else {
        this.setCurrency(enCurrency.BRL);
      }
    });
  }

  public setCurrency(currency: enCurrency) {
    this.currency$.next(currency);
  }

  public getCurrency(): Observable<enCurrency> {
    return this.currency$.asObservable().distinctUntilChanged();
  }
}

// tslint:disable-next-line:variable-name
export const CurrencyServiceFactory = () => new CurrencyService();

export const currencyService = CurrencyServiceFactory();
